import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { IOrgAccountItem } from "interfaces"
import moment from "moment";
import { Link } from "react-router-dom"
import { isHaveActionPermission } from "utills/helpers";

interface OrgAccountCardProps {
  data?: IOrgAccountItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AccountCard = ({data = [], pageSize, currentPage, _toggleActive }: OrgAccountCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((account: IOrgAccountItem, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <div>
              <SwitchButton
                checked={account.is_active}
                disabled={
                  !isHaveActionPermission(
                    "account_management",
                    "organization",
                    "edit"
                  )
                }
                onChange={() => _toggleActive(account.id, account.is_active)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <Link to={`/organization/accounts/${account.id}`} className="w-fit">
                <span className="sr-only">View Role</span>
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission(
                "account_management",
                "organization",
                "edit"
              ) ? (
                <Link
                  to={`/organization/accounts/${account.id}/edit`}
                  className="w-fit"
                >
                  <span className="sr-only">Edit Account</span>
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{index + 1}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Full Name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{account.first_name} {account.last_name}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Email
            </p>
            <p className="flex-1 text-right text-sm leading-6">{account.email}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Org name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{account.organization_name}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Role name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{account.role_name}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Created at/by
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {moment(account.created).format("DD/MM/YYYY HH:mm:ss")} <br />
              {account.created_by}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}